import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import {
  Box,
  Container,
  Typography
} from '@mui/material';

import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';

import SavingsIcon from '@mui/icons-material/Savings';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

const offers = [
  {
    title: "Investment in Mutual Funds",
    content: "To create wealth gradually while lowering risks, smart personal financial growth techniques emphasize diversified assets, disciplined saving, and efficient budgeting.",
    icon: <SavingsIcon sx={{ fontSize: 40, color: '#1a7d3b' }} />,
  },
  {
    title: "Health & General Insurance",
    content: "Health, life, and general insurance are crucial tools for financial security, helping to shield against medical bills and ensure family support in times of need.",
    icon: <HealthAndSafetyIcon sx={{ fontSize: 40, color: '#1a7d3b' }} />,
  },
  {
    title: "Investment in Assets",
    content: "Investing in stocks, bonds, mutual funds, and real estate helps diversify risks, increase wealth, and accomplish long-term financial goals.",
    icon: <HomeWorkIcon sx={{ fontSize: 40, color: '#1a7d3b' }} />,
  },
  {
    title: "Saving on Utility Bills",
    content: "Using energy-efficient appliances, conserving water, and managing electricity and gas usage can significantly reduce utility costs and boost savings.",
    icon: <LightbulbIcon sx={{ fontSize: 40, color: '#1a7d3b' }} />,
  },
];

export default function CoverflowSlider() {
  return (
    <Box sx={{ py: 5, pb: 15 }}>
      <Container>
        <Box sx={{ textAlign: "center", maxWidth: 800, mx: "auto", mb: 5 }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              fontWeight: "bold",
              mb: 3
            }}
          >
            Benefits We Offer
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}
          >
            You can save for a personal goal and also insure your health.
          </Typography>
        </Box>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          className="mySwiper"
          style={{ padding: '40px 0' }}
        >
          {offers.map((offer, idx) => (
            <SwiperSlide
              key={idx}
              // style={{
              //   background: '#e2fbdf',
              //   borderRadius: '16px',
              //   width: '320px',
              //   height: '350px',
              //   boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
              //   display: 'flex',
              //   flexDirection: 'column',
              //   justifyContent: 'center',
              //   alignItems: 'center',
              //   padding: '20px',
              //   textAlign: 'center'
              // }}
              style={{
                background: 'rgba(255, 255, 255, 0.15)', // translucent white
                borderRadius: '16px',
                width: '320px',
                height: '350px',
                boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)', // for Safari
                border: '1px solid rgba(255, 255, 255, 0.18)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
                textAlign: 'center',
              }}
            >
              <div style={{ marginBottom: 15 }}>
                {offer.icon}
              </div>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: '600', color: '#FFF' }}>
                {offer.title}
              </Typography>

              <p style={{ color: '#FFF' }}>{offer.content}</p>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Box>
  );
}
